import { TagCategoryDtoOut } from "../../generated";
import { TagCategory } from "../../model/tag/TagCategory";

export const parseTagCategory = (data: TagCategoryDtoOut): TagCategory => {
  return {
    id: data.id,
    title: data.name,
  };
};
